import router from "@/router";
import { Course as ICourse } from "@/api/models/course";

export default {
  state: {
    selectedCourse: {}
  },
  actions: {
    SETUP_SELECTED_COURSE(ctx: any, course: ICourse) {
      ctx.commit("SETUP_SELECTED_COURSE", course);
    },
    GO_TO_COURSE_PAGE(ctx: any, course: ICourse) {
      ctx.commit("SETUP_SELECTED_COURSE", course);
      router.push({
        name: "courseView",
        params: {
          courseId: course.id
        }
      });
    }
  },
  mutations: {
    SETUP_SELECTED_COURSE(state: any, course: ICourse) {
      state.selectedCourse = course;
    }
  },
  getters: {
    SELECTED_COURSE(state: any) {
      return state.selectedCourse;
    }
  }
};
